module.exports = {"meta":{"start":"Kampaň začala","title":"Odgooglování internetu"}};